import React from "react"
import PaymentOrderAttachments from "./PaymentOrderAttachments"
import { useTranslation } from "react-i18next";

const PaymentOrderComments = ({
  paymentOrder,
  setPaymentOrder,
  paymentOrderAttachments,
  setPaymentOrderAttachments,
  disabled,
  handleChange
}) => {
  const { t } = useTranslation("translations");

  return (
    <div className="row">
      <div className="col-12 mb-2">
        <div className=" font-weight-bold d-flex align-items-center input-length-validation">
          <textarea
            style={{paddingRight:"75px"}}
            placeholder={t('invoice.comment')}
            className="form-control"
            value={paymentOrder?.comment ?? ""}
            id="comment"
            rows="2"
            onChange={(e)=>handleChange(null,"comment",e.target.value)}
            disabled={disabled }
          />
        </div>
      </div>
      <div className="col-12">
        <PaymentOrderAttachments
          paymentOrder={paymentOrder}
          setPaymentOrder={setPaymentOrder}
          paymentOrderAttachments={paymentOrderAttachments}
          setPaymentOrderAttachments={setPaymentOrderAttachments}
          disabled={disabled}
        />
      </div>

    </div>
  )
}

export default PaymentOrderComments
